import { component$ } from "@builder.io/qwik";
import type { InfoItem } from "./ui/info-list";
import { InfoList } from "./ui/info-list";
import type { CoachSelect, ProfileSelect } from "~/lib/schemas";
import { Card, CardContent } from "./ui/card";
import { type CoachDetailsSelect } from "../../drizzle/schema";
import { isNotNull } from "~/lib/utils";

export const CoachDetails = component$<{
  coach: CoachSelect;
  profile: ProfileSelect;
  details?: CoachDetailsSelect;
}>(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ({ coach, profile, details }) => {
    const coachInfo: InfoItem[] = [
      ...(profile.languages
        ? [
            {
              icon: "message",
              label: "Language",
              value: profile.languages,
            } as InfoItem,
          ]
        : []),
      ...(profile.primaryCity || profile.primaryCountry
        ? [
            {
              icon: "location",
              label: "Location",
              value: [profile.primaryCity, profile.primaryCountry]
                .filter(isNotNull)
                .join(", "),
            } as InfoItem,
          ]
        : []),
      ...(profile.coachingStyle
        ? [
            {
              icon: "palette",
              label: "Coaching style",
              value: profile.coachingStyle,
            } as InfoItem,
          ]
        : []),
      ...(profile.formOfConduct
        ? [
            {
              icon: "mic",
              label: "Form of conduct",
              value: profile.formOfConduct,
            } as InfoItem,
          ]
        : []),
    ];

    const secondaryInfo: InfoItem[] = [];

    return (
      <div class="flex flex-col gap-4">
        {coachInfo.length > 0 && (
          <Card class="w-full">
            <CardContent class="p-4">
              <InfoList items={coachInfo} />
            </CardContent>
          </Card>
        )}

        {secondaryInfo.length > 0 && (
          <Card class="w-full">
            <CardContent class="p-4">
              <InfoList items={secondaryInfo} />
            </CardContent>
          </Card>
        )}
      </div>
    );
  },
);
